<div [class]="this.getStyleClass()" class="position-relative">
  <!-- filtros -->
  <div class="ly-sp-s-bottom">
    <ng-container #targetWindow></ng-container>
  </div>
  <!-- table selection counter -->
  <div class="selection-counter-container d-flex justify-content-center align-items-center th-bg-border-line-background" 
        [ngClass]="{
        'w-100' : getIsSmallSize()
        }"
        *ngIf="this.getIsSelectionCounterShown()">
        <span class="th-text-main bs-paragraph">Seleccionados : 
          <span class="fw-bold">{{this.getSelectedAdns() ? this.getSelectedAdns().length : 0}}</span>
        </span>
  </div>
  <!-- tabla -->
  <div>
    <table class="table">
      <thead *ngIf="columns" class="table-header th-bg-white">
        <tr *ngIf="columns.length > 0" class="th-text-gray-paragraphs">
          <th *ngFor="let column of columns" [hidden]="column.isHidden" class="no-border table-header-alignment">
            <div *ngIf="column.propertyRef.includes(this.columnResponsiveSeparator)" (click)="sortTableBy(column.propertyRef)" class="collapsed-column-container" >
              <div>
              <span *ngFor="let col of this.splitColumns(column)" class="d-flex flex-row align-items-center">
                <span class="bs-h3 bs-sf-pro-text">{{col}}</span>
              </span>
            </div>
            <div>
              <i *ngIf="getAllowSort()" class="fa sort-icon" [ngClass]="getSortIconClass(column.propertyRef)" aria-hidden="true"></i>
            </div>
          </div>
            <div *ngIf="!column.propertyRef.includes(this.columnResponsiveSeparator)" class="d-flex flex-row align-items-center" (click)="sortTableBy(column.propertyRef)">
              <span class="bs-h3 bs-sf-pro-text">{{column.headerTitle}}</span>
              <i *ngIf="getAllowSort()" class="fa sort-icon" [ngClass]="getSortIconClass(column.propertyRef)" aria-hidden="true"></i>
            </div>
          </th>

          <!-- actions -->
          <th *ngIf="this.areActionsAvailable" class="text-center no-border table-header-alignment">
              <span class="bs-h3 bs-sf-pro-text">Acciones</span>
          </th>

           <!-- selection -->
           <th *ngIf="this.getIsMultipleCheckSelectionAvailable()" class="text-center no-border table-header-alignment">
            <div class="d-flex gap-3 align-items-center justify-content-center">  
              <span class="bs-h3 bs-sf-pro-text" *ngIf="!isSmallSize">SELECCIONAR</span>
              <div class="checkbox-box checkbox-box-border d-flex justify-content-center align-items-center" (click)="selectAllRows()" [ngClass]="{
                'checkbox-box-active' : this.isGlobalSelectionActive
              }">
                <i class="fa fa-check th-text-white" aria-hidden="true"></i>
              </div>
            </div>
          </th>
        </tr>
      </thead>

      <tbody *ngIf="rows && actualPageRows">
        <tr *ngFor="let row of actualPageRows; let i = index" 
            (click)="onSelect(row)"
            class="th-bg-white"
            [ngClass]="{
              'selected' : row.isSelected && this.getSelectionType() === TableSelectionType.Highlight && this.getIsSelectable()
            }">
          <td *ngFor="let column of columns" 
              [style.display]="column.propertyRef ? 'table-cell' : 'none'" 
              [hidden]="column.isHidden || (getIsRowEdited() && getSelected() === row)"
              [class.no-border]="actualPageRows.length-1 === i">
            <span *ngIf="column.propertyRef && !checkCurrencyColumns(column.propertyRef)" 
                  class="bs-paragraph"
                  [ngClass]="{
                    'th-text-alert': row.fields[column.propertyRef].isDanger === true
                  }">
                  <i class="fa" *ngIf="validateColumnState(row, column)" [ngClass]="{
                    'fa-exclamation-circle th-text-alert': row.fields[column.propertyRef].isDanger === true,
                    'fa-ellipsis-v th-text-warning': row.fields[column.propertyRef].isWarning === true,
                    'fa-check-circle-o th-text-confirmation': row.fields[column.propertyRef].isSuccess === true,
                    'th-text-main' : row.fields[column.propertyRef].isPrimary === true
                  }">
                  </i>
              {{castCurrencySymbol(getCurrencySymbol())}} {{row.fields[column.propertyRef].value | number:'1.2-5'}}
            </span>

            <span *ngIf="column.propertyRef && checkCurrencyColumns(column.propertyRef) && this.getStateType() === TableStateType.icon">
              <i *ngIf="columnsWithIcons[column.propertyRef]" 
                  [ngClass]="columnsWithIcons[column.propertyRef]"></i>
              <span *ngIf="column.propertyRef !== '#ICON#'">
                <span *ngFor="let rowValue of this.getRowValue(row.fields[column.propertyRef])" 
                      class="d-flex flex-column bs-paragraph">
                  <span
                    [ngClass]="{
                      'th-text-alert': row.fields[column.propertyRef].isDanger === true
                    }">
                      <i class="fa" [ngClass]="{
                        'fa-exclamation-circle th-text-alert': row.fields[column.propertyRef].isDanger === true,
                        'fa-pause-circle-o th-text-warning': row.fields[column.propertyRef].isWarning === true,
                        'fa-check-circle-o th-text-confirmation': row.fields[column.propertyRef].isSuccess === true
                      }">
                      </i>
                    {{rowValue}}
                  </span>
                </span>
              </span>
              <span *ngIf="!column.propertyRef !== '#ICON#'"></span>
            </span>
            
            <span *ngIf="column.propertyRef && checkCurrencyColumns(column.propertyRef) && this.getStateType() === TableStateType.block">
                <span *ngFor="let rowValue of this.getRowValue(row.fields[column.propertyRef])" 
                      class="d-flex flex-column bs-paragraph" 
                      [ngClass]="getBlockTypeClases(row.fields[column.propertyRef])">
                  <span>
                    {{rowValue}}
                  </span>
                </span>
            </span>
          </td>

          <!-- actions -->
          <td *ngIf="this.areActionsAvailable" 
              [class.no-border]="actualPageRows.length-1 === i">
              <ng-container #buttonContainer></ng-container>
          </td>

          <!-- selection -->
          <td *ngIf="this.getIsCheckSelectionAvailable()"
              [class.no-border]="actualPageRows.length-1 === i">
              <div class="w-100 d-flex justify-content-center"> 
                <div class="checkbox-box checkbox-box-border d-flex justify-content-center align-items-center" 
                     (click)="onRowSelected($event,row)" 
                     [ngClass]="{
                      'checkbox-box-active' : row.isSelected
                      }">
                  <i class="fa fa-check th-text-white" aria-hidden="true"></i>
                </div>
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- when no data is present -->
  <div *ngIf="!getTableData() || getTableData().length === 0" 
       class="no-data-container d-flex justify-content-center align-items-center th-bg-white">
    <span class="th-text-gray-paragraphs">No hay resultados para su búsqueda</span>
  </div>

  <!-- pagination  -->
  <div class="d-flex align-items-center justify-content-between" 
       *ngIf="getTableData() && getTableData().length > 0"
       [class.flex-column]="this.getIsSmallSize()"
       [class.gap-2]="this.getIsSmallSize()">
    <div [class.mobile-rows-per-page]="this.getIsSmallSize()">
      <div style="padding: 10px 0 0 10px">
        <div class="d-flex align-items-center">
          <span class="th-text-gray-paragraphs me-2">Régistros por página:</span>

          <div class="d-flex flex-column">
            <div class="select-container cursor-pointer th-line th-bg-white d-flex th-text-gray-paragraphs" 
                 (click)="this.changeDropdownState()"
                 [class.select-container-borders]="!this.isSelectForRowsOpen">
              <div class="label-select w-50 d-flex justify-content-center align-items-center th-text-gray-paragraphs">
                {{this.getSelectRowsPerPage()}}
              </div>
              <div class="select-arrow w-50 d-flex justify-content-center align-items-center th-text-gray-paragraphs">
                <i class="fa fa-angle-down select-icons" aria-hidden="true" *ngIf="!this.isSelectForRowsOpen"></i>
                <i class="fa fa-chevron-up select-icons" aria-hidden="true" *ngIf="this.isSelectForRowsOpen"></i>
              </div>
            </div>
            <div class="dropdown select-container-borders th-line th-bg-white" [hidden]="!this.isSelectForRowsOpen" >
              <div class="dropdown-option cursor-pointer d-flex justify-content-center align-items-center"
                   [class.last-dropdown-option]="this.rowsPerPageArr.length-1 === selectOptionIdx"
                   *ngFor="let item of this.rowsPerPageArr; let selectOptionIdx=index" (click)="this.onSelectOptionClick(selectOptionIdx)">
                   <span class="th-text-gray-paragraphs">{{item}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center th-text-gray-paragraphs"
         [class.mobile-current-page]="this.getIsSmallSize()">
      Mostrando {{this.actualPageRows.length}} de {{this.rows.length}}
    </div>

    <div [class.mobile-pagination-box]="this.getIsSmallSize()">
      <div class="d-flex align-items-center gap-2">
        <div>
          <a (click)="loadPageRows(getCurrentPage() - 1)">
            <i class="fa fa-angle-left th-text-gray-paragraphs fa-2x cursor-pointer" aria-hidden="true"></i>
          </a>
        </div>
        <div class="d-flex gap-2">
          <div class="pagination-box 
                      d-flex 
                      justify-content-center 
                      align-items-center 
                      th-bg-main
                      th-blue-line
                      th-text-white
                      user-select-none
                      ">
            <span>{{getCurrentPage() + 1}}</span>
          </div>
        </div>
        <div>
          <a (click)="loadPageRows(getCurrentPage() + 1)">
            <i class="fa fa-angle-right th-text-gray-paragraphs fa-2x cursor-pointer" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>